import { CLIENTS, CONTROLS, DDQ, DETAILS, DISCUSSION, DOCUMENTS, DRAFT, FRAMEWORKS, GROUPS, PUBLIC, QUESTIONS, SERVICES, SUMMARY, TPRM } from 'Config/Paths';
import { ResponseModel } from 'Models/ResponseModel';
import { ControlFrameworkInstanceResponse, CreateDDQDiscussionDraftRequest, DDQDiscussionDraft, QuestionnaireGroupControlsResponse, SubmitDDQDiscussionRequest, ThirdPartyService, UpdateControlInstanceQuestionsRequest, VendorQuestionnaireAggregationResponse } from 'Models/TPRM';
import { publicRestApiDelete, publicRestApiGet, publicRestApiPost } from 'PublicRestApiConnector';

import { DDQApi } from './DDQApi';

export class AWSPublicDDQApi implements DDQApi {
    getServiceDetails = (thirdPartyId: string, serviceId: string): Promise<ResponseModel<ThirdPartyService>> => {
        return publicRestApiGet(`/${PUBLIC}/${TPRM}/${SERVICES}/`, {});
    };

    getQuestionnaireFrameworks = (thirdPartyId: string, serviceId: string): Promise<ResponseModel<ControlFrameworkInstanceResponse[]>> => {
        return publicRestApiGet(`/${PUBLIC}/${TPRM}/${DDQ}/${FRAMEWORKS}/`);
    };

    getQuestionnaireGroupControls = (thirdPartyId: string, serviceId: string, controlFramework: string, controlGroupId: string): Promise<ResponseModel<QuestionnaireGroupControlsResponse>> => {
        return publicRestApiGet(`/${PUBLIC}/${TPRM}/${DDQ}/${FRAMEWORKS}/${controlFramework}/${GROUPS}/${controlGroupId}`);
    };

    thirdPartySaveControl = (thirdPartyId: string, serviceId: string, controlFramework: string, controlGroupId: string, controlId: string, request: UpdateControlInstanceQuestionsRequest): Promise<ResponseModel<void>> => {
        return publicRestApiPost(`/${PUBLIC}/${TPRM}/${DDQ}/${FRAMEWORKS}/${controlFramework}/${GROUPS}/${controlGroupId}/${CONTROLS}/${controlId}`, request);
    };
    deleteAnswerDocument = (thirdPartyId: string, serviceId: string, controlFramework: string, controlGroupId: string, controlId: string, questionId: string, documentId: string): Promise<ResponseModel<void>> => {
        return publicRestApiDelete(`/${PUBLIC}/${TPRM}/${DDQ}/${FRAMEWORKS}/${controlFramework}/${GROUPS}/${controlGroupId}/${CONTROLS}/${controlId}/${QUESTIONS}/${questionId}/${DOCUMENTS}/${documentId}`);
    };

    getQuestionnaireDiscussionDraft = (thirdPartyId: string, serviceId: string): Promise<ResponseModel<DDQDiscussionDraft[]>> => {
        return publicRestApiGet(`/${PUBLIC}/${TPRM}/${DDQ}/${DISCUSSION}`);
    };
    createQuestionnaireDiscussionDraft = (thirdPartyId: string, serviceId: string, request: CreateDDQDiscussionDraftRequest): Promise<ResponseModel<void>> => {
        return publicRestApiPost(`/${PUBLIC}/${TPRM}/${DDQ}/${DISCUSSION}/${DRAFT}`, request);
    };

    updateQuestionnaireDiscussionDraft = (thirdPartyId: string, serviceId: string, discussionId: string, request: CreateDDQDiscussionDraftRequest): Promise<ResponseModel<void>> => {
        return publicRestApiPost(`/${PUBLIC}/${TPRM}/${DDQ}/${DISCUSSION}/${DRAFT}/${discussionId}`, request);
    };

    deleteQuestionnaireDiscussionDraft = (thirdPartyId: string, serviceId: string, discussionId: string): Promise<ResponseModel<void>> => {
        return publicRestApiDelete(`/${PUBLIC}/${TPRM}/${DDQ}/${DISCUSSION}/${DRAFT}/${discussionId}`);
    };

    markQuestionnaireAsComplete = (thirdPartyId: string, serviceId: string): Promise<ResponseModel<void>> => {
        return publicRestApiPost(`/${PUBLIC}/${TPRM}/${DDQ}`, {});
    };

    getQuestionnaireAggregation = (thirdPartyId: string, serviceId: string): Promise<ResponseModel<VendorQuestionnaireAggregationResponse> | undefined> => {
        return publicRestApiGet(`/${PUBLIC}/${TPRM}/${DDQ}/${SUMMARY}/`);
    };

    submitQuestionnaireDiscussion = (thirdPartyId: string, serviceId: string, request: SubmitDDQDiscussionRequest): Promise<ResponseModel<void>> => {
        return publicRestApiPost(`/${PUBLIC}/${TPRM}/${DDQ}/${DISCUSSION}/`, request);
    };

    getClientDetails = (): Promise<ResponseModel<string>> => {
        return publicRestApiGet(`/${PUBLIC}/${CLIENTS}/${DETAILS}`, {});
    };
}
